import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

export type SupabaseClient = typeof supabase

/** Human-readable message from PostgREST / Supabase client errors (rpc, from, etc.). */
export function formatSupabaseClientError(err: unknown): string {
  if (err instanceof Error && err.message) return err.message
  if (!err || typeof err !== 'object') return 'Something went wrong'
  const e = err as { message?: string; details?: string; hint?: string }
  const parts = [e.message, e.details, e.hint].filter(
    (x): x is string => typeof x === 'string' && x.trim().length > 0,
  )
  return parts.length > 0 ? parts.join(' — ') : 'Something went wrong'
}
